<template>

  <div>

    <h3>Conférences à venir</h3>

    <table class="table" v-if="conferences.length > 0">
      <thead>
      <tr>
        <th>Nom</th>
        <th>Date</th>
        <th>Lien</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="conference in conferences">
        <tr :key="'data-' + conference.id">
          <td>{{ conference.title }}</td>
          <td>{{ conference.date | formatDateAndTime }}</td>
          <td><a :href="conference.url" target="_blank">{{ conference.url }}</a></td>
        </tr>
        <tr :key="'description-' + conference.id">
          <td colspan="3">
            <vue-markdown :source="conference.description"/>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
    <div v-else>Aucune conférence pour le moment</div>

  </div>

</template>

<script>
  import { mapState } from "vuex";

  export default {
    name: 'MembreConference',
    computed: {
      ...mapState({
        conferences: state => state.members.conferences
      }),
    }
  };
</script>

<style scoped>

</style>
